//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------
export const handleGetWelcomeVideos = () => async (dispatch) => {
	try {
		const videos = await apis.get('resources', `/getWelcomeVideoUrl`)
		if (videos) {
			await dispatch(Actions.setWelcomeVideos(videos));
		}
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting welcome videos',
                error,
                module: 'WELCOME_VIDEO',
                operation: 'GET_WELCOME_VIDEO'
            });
		}
	}
};

export const handleUpdateWelcomeVideos = (data) => async (dispatch) => {
	try {
		const videos = await apis.put('resources', `/updateWelcomeVideos`,{
			body:data
		})
		if (videos) {
			await dispatch(Actions.updateWelcomeVideos(videos));
		}
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'updating welcome videos',
                error,
                module: 'WELCOME_VIDEO',
                operation: 'UPDATE_WELCOME_VIDEO'
            });
		}
	}
};

